import { useLocale } from '@bees-web/core/shared/contexts'
import { initializeState } from '@bees-web/nfa-interactive-global'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

/**
 * @deprecated
 */
export function useInitializeUser() {
  const dispatch = useDispatch()
  const { language, country } = useLocale()

  useEffect(() => {
    dispatch(initializeState({ country, language }))
  }, [dispatch, language, country])
}
